import http from "/src/httpRequest.js";
export default {
  actions: {
    async getWhoWeAre(context) {
      const response = await http.get("whoWeAre");
      context.commit("setWhoWeAre", response.data);
    },
  },
};
